<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Modifica analisi</h4>
    <button type="button" class="text-white close" aria-label="Close" (click)="modal.close({isEdited:edited})">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <fieldset>
        <div class="form-group col mb-3">
            <label for="id_azienda_lavori">Campo</label>
            <select class="custom-select filter" id="id_azienda_lavori" [(ngModel)]="activeField"
                (ngModelChange)="onActiveFieldChange($event)" name="id_azienda_lavori">
                <option *ngFor="let field of fieldChoiceDropdown" [value]="field.value">{{ field.label }}</option>
            </select>
        </div>

        <hr>

        <form [formGroup]="editForm">
            <div class="form-group col" *ngIf="activeField === 'piano_lavori'">
                <label for="piano_lavori">Piano lavori</label>
                <div class="input-group">
                    <input type="text" id="piano_lavori" class="form-control filter" formControlName="piano_lavori">
                </div>
            </div>
            <div class="form-group col" *ngIf="activeField === 'anno_piano_lavori'">
                <label for="anno_piano_lavori">Anno Piano lavori</label>
                <div class="input-group">
                    <input type="text" id="anno_piano_lavori" class="form-control filter" formControlName="anno_piano_lavori">
                </div>
            </div>
            <div class="form-group col" *ngIf="activeField === 'nome_sito'">
                <label for="nome_sito">Nome sito</label>
                <div class="input-group">
                    <input type="text" id="nome_sito" class="form-control filter" formControlName="nome_sito">
                </div>
            </div>
            <div class="form-group col" *ngIf="activeField === 'sr'">
                <label for="sr">SR</label>
                <div class="input-group">
                    <input type="text" id="sr" class="form-control filter" formControlName="sr">
                </div>
            </div>

            <div class="form-group col" *ngIf="activeField === 'colore'">
                <span>
                    <label for="colore" class="d-block">Colore</label>
                    <div class="color-preview d-block my-2 border" [ngStyle]="{'background': cpColor}"></div>
                </span>

                <input class="form-control" formControlName="colore" id="colore" name="colore" [colorPicker]="cpColor"
                    [cpPosition]="cpPosition" (colorPickerChange)="onChangeColor($event)"
                    pattern="^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$" autocomplete="off" />
            </div>
        </form>
    </fieldset>
</div>

<div class="modal-footer">

    <button type="button" class="btn bg-blu txt-white" (click)="onSubmit()">Salva</button>
    <button type="button" class="btn btn-bg-outline" (click)="modal.close({isEdited:edited})">
        Chiudi
    </button>
</div>